import { render, staticRenderFns } from "./CombinedMetrics.vue?vue&type=template&id=657a8149&"
import script from "./CombinedMetrics.vue?vue&type=script&lang=ts&"
export * from "./CombinedMetrics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports